import { z } from "zod";

export const EnvZodEnum = z.enum(["local", "staging", "prod", "preview"]);
export type EnvName = z.infer<typeof EnvZodEnum>;

export const EnvMetaZod = z.object({
  frontendUrl: z.string(),
  proxyRouterUrl: z.string(),
  nodeBackendUrl: z.string(),
  supabaseUrl: z.string(),
  supabaseAnonKey: z.string(),
});
export type EnvMetaType = z.infer<typeof EnvMetaZod>;

export const ENVIRONMENTS: Record<EnvName, EnvMetaType> = {
  local: {
    frontendUrl: "http://localhost:5173/",
    proxyRouterUrl: "https://api-test.floppydata.com/v1/",
    nodeBackendUrl: "http://localhost:8787/",
    supabaseUrl: "https://fasufaflquxbbivmsxwg.supabase.co",
    supabaseAnonKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZhc3VmYWZscXV4YmJpdm1zeHdnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3ODg4ODUsImV4cCI6MjA1NTM2NDg4NX0.DNwwiN1pnNqm_9zqH0L0mPFPaNjcKl77EMbqhTtjlSs",
  },
  staging: {
    frontendUrl: "https://fd-preview.netlify.app/",
    proxyRouterUrl: "https://api-test.floppydata.com/v1/",
    nodeBackendUrl: "https://floppydata-backend.alex-0da.workers.dev/",
    supabaseUrl: "https://fasufaflquxbbivmsxwg.supabase.co",
    supabaseAnonKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZhc3VmYWZscXV4YmJpdm1zeHdnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3ODg4ODUsImV4cCI6MjA1NTM2NDg4NX0.DNwwiN1pnNqm_9zqH0L0mPFPaNjcKl77EMbqhTtjlSs",
  },
  preview: {
    frontendUrl: "https://floppydata.netlify.app/",
    proxyRouterUrl: "https://api.floppydata.com/v1/",
    nodeBackendUrl: "https://fdapi777.alex-0da.workers.dev/",
    supabaseUrl: "https://vizreqqtoljlznylvnsk.supabase.co",
    supabaseAnonKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpenJlcXF0b2xqbHpueWx2bnNrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI4Njc4MjEsImV4cCI6MjA0ODQ0MzgyMX0.AlJL1uhFWWLy1cTTRpelGA_O9DkvFOvG-CipIoSV0_Q",
  },
  prod: {
    frontendUrl: "https://app.floppydata.com/",
    proxyRouterUrl: "https://api.floppydata.com/v1/",
    nodeBackendUrl: "https://fdapi777.alex-0da.workers.dev/",
    supabaseUrl: "https://vizreqqtoljlznylvnsk.supabase.co",
    supabaseAnonKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpenJlcXF0b2xqbHpueWx2bnNrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI4Njc4MjEsImV4cCI6MjA0ODQ0MzgyMX0.AlJL1uhFWWLy1cTTRpelGA_O9DkvFOvG-CipIoSV0_Q",
  },
};
